export default {
  setPhysicianSignUpData(state, data) {
    state.data = data
    sessionStorage.setItem('physician-sign-up-data', JSON.stringify(state.data))
  },
}
